module.exports = "//public.zight.com/packs/media/images/buttons-add-new-collection-hover-f6a5ea5857dd752fe4761d9de704d1e4.svg";